import ProgramsPlaylistPage from "./Playlist";
import _WeeklyProgramsPage from "./Weekly";
import _CulturalProgramsPage from "./Cultural/Cultural";
import _CulturalSubFolder from "./Cultural/SubFolder";

export const WeeklyProgramsPage = _WeeklyProgramsPage;
export const CulturalProgramsPage = _CulturalProgramsPage;
export const CulturalSubFolder = _CulturalSubFolder;
export default ProgramsPlaylistPage;
